var _objectSpread = require("/Users/klatibook/git/adex-platform/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _defineProperty = require("/Users/klatibook/git/adex-platform/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _toConsumableArray = require("/Users/klatibook/git/adex-platform/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/Users/klatibook/git/adex-platform/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var bs58 = require('bs58');

var _require = require('./constants'),
    CountryTiers = _require.CountryTiers,
    OsGroups = _require.OsGroups;

var _require2 = require('@ethersproject/units'),
    formatUnits = _require2.formatUnits,
    parseUnits = _require2.parseUnits;

var IPFS_BASE_58_LEADING = '1220';

var ipfsHashTo32BytesHex = function ipfsHashTo32BytesHex(ipfsHash) {
  var ipfs58Buf = bs58.decode(ipfsHash);
  var hex = ipfs58Buf.toString('hex').replace(new RegExp('^' + IPFS_BASE_58_LEADING), '0x');
  return hex;
};

var from32BytesHexIpfs = function from32BytesHexIpfs(ipfsHex) {
  var fullHex = ipfsHex.replace(new RegExp('^' + '0x'), IPFS_BASE_58_LEADING);
  var bytes = Buffer.from(fullHex, 'hex');
  var ipfsHash = bs58.encode(bytes);
  return ipfsHash;
};

var toLowerCaseString = function toLowerCaseString(obj) {
  //Maybe defaut value ot validation but for its current use case is good to throw
  return obj.toString().toLowerCase();
};

var getAdSizeByType = function getAdSizeByType(type) {
  var _type$split$1$split = type.split('_')[1].split('x'),
      _type$split$1$split2 = _slicedToArray(_type$split$1$split, 2),
      width = _type$split$1$split2[0],
      height = _type$split$1$split2[1];

  return {
    width: width,
    height: height,
    valueTxt: type,
    label: 'LABEL_SIZE_PX',
    labelArgs: [width, height]
  };
}; // TODO: fix it


var getMediaUrlWithProvider = function getMediaUrlWithProvider() {
  var mediaUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'ipfs://';
  var provider = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return provider + mediaUrl.substring(7);
};

var areAllCountriesSelected = function areAllCountriesSelected() {
  var inputCountries = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return inputCountries && inputCountries.length ? Object.keys(CountryTiers).every(function (c) {
    return inputCountries.includes(c);
  }) : false;
};

var areAllDevicesSelected = function areAllDevicesSelected() {
  var inputDevices = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return inputDevices && inputDevices.length ? Object.keys(OsGroups).every(function (c) {
    return inputDevices.includes(c);
  }) : false;
};

var inputCountriesToRuleCountries = function inputCountriesToRuleCountries() {
  var inputCountries = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var ruleCountries = inputCountries.reduce(function (all, c) {
    var countries = CountryTiers[c] ? CountryTiers[c].countries : [c];
    return all.concat(countries);
  }, []).filter(function (c, i, all) {
    return all.indexOf(c) === i;
  });
  return ruleCountries;
}; // by userAgentOS


var inputDevicesToRuleDevices = function inputDevicesToRuleDevices() {
  var inputDevices = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var ruleDevices = inputDevices.reduce(function (all, d) {
    var agentOs = OsGroups[d] ? OsGroups[d].oss : [d];
    return all.concat(agentOs);
  }, []).filter(function (c, i, all) {
    return all.indexOf(c) === i;
  });
  return ruleDevices;
};

var getLevelOneCategory = function getLevelOneCategory(cat) {
  return cat.split('-')[0];
};

var getSuggestedPricingBoundsV1 = function getSuggestedPricingBoundsV1(_ref) {
  var minByCategory = _ref.minByCategory,
      countryTiersCoefficients = _ref.countryTiersCoefficients,
      audienceInput = _ref.audienceInput;
  var inputs = audienceInput.inputs;
  var _inputs$location = inputs.location,
      location = _inputs$location === void 0 ? {} : _inputs$location,
      _inputs$categories = inputs.categories,
      categories = _inputs$categories === void 0 ? {} : _inputs$categories,
      _inputs$publishers = inputs.publishers,
      publishers = _inputs$publishers === void 0 ? {} : _inputs$publishers,
      _inputs$advanced = inputs.advanced,
      advanced = _inputs$advanced === void 0 ? {} : _inputs$advanced;
  var selectedCategoriesMinCpms = Object.values(Object.fromEntries(Object.entries(minByCategory).filter(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        key = _ref3[0],
        value = _ref3[1];

    var inSelected = !categories.apply.includes('in') || !categories.in || !categories.in.length || categories.in.some(function (c) {
      return c === 'ALL' || key === getLevelOneCategory(c);
    });
    var notExcluded = !categories.apply.includes('nin') || !(categories.nin || []).some(function (c) {
      return key === getLevelOneCategory(c);
    });
    return inSelected && notExcluded;
  }))); // Set min category from all as default if no selected categories

  var minCategoryCpm = Math.min.apply(Math, _toConsumableArray(Object.values(minByCategory)));
  var minCat = selectedCategoriesMinCpms.length ? Math.min.apply(Math, _toConsumableArray(selectedCategoriesMinCpms)) : minCategoryCpm;
  var maxCat = selectedCategoriesMinCpms.length ? Math.max.apply(Math, _toConsumableArray(selectedCategoriesMinCpms)) : minCategoryCpm;
  var selectedCountryCoefficients = Object.entries(CountryTiers).filter(function (_ref4) {
    var _ref5 = _slicedToArray(_ref4, 2),
        key = _ref5[0],
        value = _ref5[1];

    if (location.apply == 'allin') {
      return true;
    }

    var isInThisTier = (location[location.apply] || []).some(function (c) {
      return c === key || value.countries.includes(c);
    });

    if (location.apply == 'in') {
      return isInThisTier;
    }

    if (location.apply == 'nin') {
      return !isInThisTier;
    }

    return false;
  }).map(function (_ref6) {
    var _ref7 = _slicedToArray(_ref6, 2),
        key = _ref7[0],
        _ = _ref7[1];

    return countryTiersCoefficients[key];
  }); // Set min country coefficient from all as default if no selected countries

  var minTierCoefficient = Math.min.apply(Math, _toConsumableArray(Object.values(countryTiersCoefficients)));
  var minCountryCoef = selectedCountryCoefficients.length ? Math.min.apply(Math, _toConsumableArray(selectedCountryCoefficients)) : minTierCoefficient;
  var maxCountryCoef = selectedCountryCoefficients.length ? Math.max.apply(Math, _toConsumableArray(selectedCountryCoefficients)) : minTierCoefficient; // Returns decimal strings as user input values because it is not used for calculations

  return {
    IMPRESSION: {
      min: (minCat * minCountryCoef).toFixed(2),
      max: (maxCat * maxCountryCoef).toFixed(2)
    }
  };
};

var getSuggestedPricingBounds = function getSuggestedPricingBounds(_ref8) {
  var minByCategory = _ref8.minByCategory,
      countryTiersCoefficients = _ref8.countryTiersCoefficients,
      audienceInput = _ref8.audienceInput;

  if (audienceInput.version === '1') {
    return getSuggestedPricingBoundsV1({
      minByCategory: minByCategory,
      countryTiersCoefficients: countryTiersCoefficients,
      audienceInput: audienceInput
    });
  }
};

var getPublisherRulesV1 = function getPublisherRulesV1(publishers) {
  var action = publishers.apply;

  if (action === 'allin') {
    return [];
  } else {
    var _publishers$action$re = publishers[action].reduce(function (rules, value) {
      var _JSON$parse = JSON.parse(value),
          hostname = _JSON$parse.hostname,
          publisher = _JSON$parse.publisher;

      if (hostname) {
        rules.hostnames.add(hostname);
      }

      if (publisher) {
        rules.publisherIds.add(publisher);
      }

      return rules;
    }, {
      publisherIds: new Set(),
      hostnames: new Set()
    }),
        publisherIds = _publishers$action$re.publisherIds,
        hostnames = _publishers$action$re.hostnames;

    return [{
      onlyShowIf: _defineProperty({}, action, [Array.from(publisherIds.values()), {
        get: 'publisherId'
      }])
    }, {
      onlyShowIf: _defineProperty({}, action, [Array.from(hostnames.values()), {
        get: 'adSlot.hostname'
      }])
    }];
  }
};

var getClampedNumber = function getClampedNumber(x, min, max) {
  if (x < min) {
    return min;
  }

  if (x > max) {
    return max;
  }

  return x;
};

var getSelectedCountryTiersFormAudienceInput = function getSelectedCountryTiersFormAudienceInput(location) {
  var apply = location.apply;

  if (apply === 'in') {
    return Object.fromEntries(Object.entries(_objectSpread({}, CountryTiers)).filter(function (_ref9) {
      var _ref10 = _slicedToArray(_ref9, 2),
          key = _ref10[0],
          value = _ref10[1];

      return location.in.some(function (x) {
        return x === key || value.countries.includes(x);
      });
    }).map(function (_ref11) {
      var _ref12 = _slicedToArray(_ref11, 2),
          key = _ref12[0],
          value = _ref12[1];

      if (location.in.includes(key)) {
        return [key, value];
      }

      var countries = _toConsumableArray(value.countries).filter(function (x) {
        return location.in.includes(x);
      });

      return [key, _objectSpread(_objectSpread({}, value), {}, {
        countries: countries
      })];
    }));
  } else if (apply === 'nin') {
    return Object.fromEntries(Object.entries(CountryTiers).map(function (_ref13) {
      var _ref14 = _slicedToArray(_ref13, 2),
          key = _ref14[0],
          value = _ref14[1];

      var countries = location.nin.includes(key) ? [] : _toConsumableArray(value.countries).filter(function (x) {
        return !location.nin.includes(x);
      });
      return [key, _objectSpread(_objectSpread({}, value), {}, {
        countries: countries
      })];
    }).filter(function (_ref15) {
      var _ref16 = _slicedToArray(_ref15, 2),
          key = _ref16[0],
          value = _ref16[1];

      return !!value.countries.length;
    }));
  }

  return _objectSpread({}, CountryTiers);
};

var getPriceRulesV1 = function getPriceRulesV1(_ref17) {
  var audienceInput = _ref17.audienceInput,
      countryTiersCoefficients = _ref17.countryTiersCoefficients,
      pricingBounds = _ref17.pricingBounds,
      decimals = _ref17.decimals;
  var inputs = audienceInput.inputs;
  var _inputs$location2 = inputs.location,
      location = _inputs$location2 === void 0 ? {} : _inputs$location2,
      _inputs$categories2 = inputs.categories,
      categories = _inputs$categories2 === void 0 ? {} : _inputs$categories2,
      _inputs$publishers2 = inputs.publishers,
      publishers = _inputs$publishers2 === void 0 ? {} : _inputs$publishers2,
      _inputs$advanced2 = inputs.advanced,
      advanced = _inputs$advanced2 === void 0 ? {} : _inputs$advanced2; // using floats for easier math as it is no crucial

  var userPricingBounds = {
    min: parseFloat(formatUnits(pricingBounds.IMPRESSION.min, decimals)),
    max: parseFloat(formatUnits(pricingBounds.IMPRESSION.max, decimals))
  };
  var selectedTiers = getSelectedCountryTiersFormAudienceInput(location);
  var selectedTiersOrdered = Object.entries(countryTiersCoefficients).filter(function (_ref18) {
    var _ref19 = _slicedToArray(_ref18, 2),
        key = _ref19[0],
        value = _ref19[1];

    return !!selectedTiers[key];
  }).sort(function (a, b) {
    return a[1] - b[1];
  }); // The lowest tier is with coefficient is 1 as it is already calculated in pricingBounds
  // then we normalize the higher tiers coefficients to the lowest one

  var normalizedCountryTiersCoefficients = Object.fromEntries(selectedTiersOrdered.map(function (_ref20, index, entries) {
    var _ref21 = _slicedToArray(_ref20, 2),
        key = _ref21[0],
        value = _ref21[1];

    if (index === 0) {
      return [key, 1];
    } else {
      var normalizedCoefficient = countryTiersCoefficients[key] / countryTiersCoefficients[entries[0][0]];
      return [key, normalizedCoefficient];
    }
  }));
  var topSelectedTier = selectedTiersOrdered.pop()[0];
  var rules = []; // Add price rules for each tier

  Object.values(selectedTiers).forEach(function (tier) {
    var multiplier = normalizedCountryTiersCoefficients[tier.ruleValue];
    var isTopSelectedTier = topSelectedTier === tier.ruleValue; // If multiplier === 1 this is min tier so no rule
    // If only one tier is selected it actually min tier and top tier at the same time
    // In this case we count it as top tier and set the max bound

    if (multiplier !== 1 || isTopSelectedTier) {
      var price = isTopSelectedTier ? userPricingBounds.max : userPricingBounds.min * multiplier;
      var tierPrice = getClampedNumber(price, userPricingBounds.min, userPricingBounds.max);
      rules.push({
        if: [{
          in: [_toConsumableArray(tier.countries), {
            get: 'country'
          }]
        }, {
          set: ['price.IMPRESSION', {
            bn: parseUnits(tierPrice.toFixed(8), decimals).toString()
          }]
        }]
      });
    }
  });
  return rules;
}; // pricingBounds per action BN string


var audienceInputToTargetingRules = function audienceInputToTargetingRules(_ref22) {
  var audienceInput = _ref22.audienceInput,
      minByCategory = _ref22.minByCategory,
      countryTiersCoefficients = _ref22.countryTiersCoefficients,
      pricingBounds = _ref22.pricingBounds,
      decimals = _ref22.decimals;

  if (audienceInput.version === '1') {
    var inputs = audienceInput.inputs;
    var _inputs$location3 = inputs.location,
        location = _inputs$location3 === void 0 ? {} : _inputs$location3,
        _inputs$categories3 = inputs.categories,
        categories = _inputs$categories3 === void 0 ? {} : _inputs$categories3,
        _inputs$publishers3 = inputs.publishers,
        publishers = _inputs$publishers3 === void 0 ? {} : _inputs$publishers3,
        _inputs$advanced3 = inputs.advanced,
        advanced = _inputs$advanced3 === void 0 ? {} : _inputs$advanced3,
        _inputs$devices = inputs.devices,
        devices = _inputs$devices === void 0 ? {} : _inputs$devices;
    var allCountriesSelected = location.apply === 'allin' || areAllCountriesSelected(location[location.apply]);
    var allDevicesSelected = devices.apply === 'allin' || areAllDevicesSelected(devices[devices.apply]);
    var rules = [// Set base price - required for cpm update
    {
      set: ['price.IMPRESSION', {
        bn: pricingBounds.IMPRESSION.min
      }]
    }].concat(_toConsumableArray(!allCountriesSelected ? [{
      onlyShowIf: _defineProperty({}, location.apply, [inputCountriesToRuleCountries(location[location.apply]), {
        get: 'country'
      }])
    }] : []), _toConsumableArray(allCountriesSelected && location.apply === 'in' ? [] : []), _toConsumableArray(allCountriesSelected && location.apply === 'nin' ? [{
      onlyShowIf: false
    }] : []), _toConsumableArray(getPublisherRulesV1(publishers)), _toConsumableArray(categories.apply && categories.apply.includes('in') && !categories.in.includes('ALL') ? [{
      onlyShowIf: {
        intersects: [{
          get: 'adSlot.categories'
        }, categories.in]
      }
    }] : []), _toConsumableArray(categories.apply && categories.apply.includes('nin') ? [{
      onlyShowIf: {
        not: {
          intersects: [{
            get: 'adSlot.categories'
          }, categories.nin]
        }
      }
    }] : []), _toConsumableArray(advanced.includeIncentivized ? [] : [{
      onlyShowIf: {
        nin: [{
          get: 'adSlot.categories'
        }, 'IAB25-7']
      }
    }]), _toConsumableArray(advanced.disableFrequencyCapping ? [] : [{
      onlyShowIf: {
        gt: [{
          get: 'adView.secondsSinceCampaignImpression'
        }, 300]
      }
    }]), _toConsumableArray(advanced.limitDailyAverageSpending ? [{
      onlyShowIf: {
        lt: [{
          get: 'campaignTotalSpent'
        }, {
          div: [{
            mul: [{
              get: 'campaignSecondsActive'
            }, {
              get: 'campaignBudget'
            }]
          }, {
            get: 'campaignSecondsDuration'
          }]
        }]
      }
    }] : []), _toConsumableArray(getPriceRulesV1({
      audienceInput: audienceInput,
      minByCategory: minByCategory,
      countryTiersCoefficients: countryTiersCoefficients,
      pricingBounds: pricingBounds,
      decimals: decimals
    })), _toConsumableArray(!allDevicesSelected && devices.apply ? [{
      onlyShowIf: _defineProperty({}, devices.apply, [inputDevicesToRuleDevices(devices[devices.apply]), {
        get: 'userAgentOS'
      }])
    }] : []));
    return rules;
  }

  throw new Error('INVALID_AUDIENCE_INPUT_VERSION');
};

var slotRulesInputToTargetingRules = function slotRulesInputToTargetingRules(_ref23) {
  var rulesInput = _ref23.rulesInput,
      suggestedMinCPM = _ref23.suggestedMinCPM,
      decimals = _ref23.decimals;

  if (!suggestedMinCPM) {
    throw new Error('INVALID_SUGGESTED_MIN_CPM');
  }

  if (!decimals) {
    throw new Error('INVALID_DECIMALS');
  }

  if (rulesInput.version === '1') {
    var inputs = rulesInput.inputs;
    var _inputs$allowAdultCon = inputs.allowAdultContent,
        allowAdultContent = _inputs$allowAdultCon === void 0 ? false : _inputs$allowAdultCon,
        _inputs$autoSetMinCPM = inputs.autoSetMinCPM,
        autoSetMinCPM = _inputs$autoSetMinCPM === void 0 ? false : _inputs$autoSetMinCPM;
    var rules = [].concat(_toConsumableArray(autoSetMinCPM || suggestedMinCPM ? [// NOTE: We pass CPM but the rule is for impression
    {
      onlyShowIf: {
        gt: [{
          get: 'price.IMPRESSION'
        }, {
          bn: parseUnits(suggestedMinCPM, decimals).div(1000).toString()
        }]
      }
    }] : []), _toConsumableArray(allowAdultContent ? [] : [{
      onlyShowIf: {
        not: {
          intersects: [{
            get: 'adUnitCategories'
          }, ['IAB25-2', 'IAB25-3', 'IAB25-4', 'IAB25-5']]
        }
      }
    }]));
    return rules;
  }

  throw new Error('INVALID_RULES_INPUT_VERSION');
};

var userInputValuePerMileToTokenValue = function userInputValuePerMileToTokenValue() {
  var _ref24 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      value = _ref24.value,
      decimals = _ref24.decimals,
      _ref24$divBy = _ref24.divBy,
      divBy = _ref24$divBy === void 0 ? 1 : _ref24$divBy,
      _ref24$mulBy = _ref24.mulBy,
      mulBy = _ref24$mulBy === void 0 ? 1 : _ref24$mulBy;

  return parseUnits(value, decimals).mul(mulBy || 1).div(1000).div(divBy || 1).toString();
};

var bondPerActionToUserInputPerMileValue = function bondPerActionToUserInputPerMileValue(actionValue) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  // hax instead bigNumberify
  return formatUnits(parseUnits(actionValue, 0).mul(1000), decimals).toString();
};

var userInputPricingBoundsPerMileToRulesValue = function userInputPricingBoundsPerMileToRulesValue(_ref25) {
  var pricingBounds = _ref25.pricingBounds,
      decimals = _ref25.decimals,
      _ref25$minCoef = _ref25.minCoef,
      minCoef = _ref25$minCoef === void 0 ? 1 : _ref25$minCoef,
      _ref25$maxCoef = _ref25.maxCoef,
      maxCoef = _ref25$maxCoef === void 0 ? 1 : _ref25$maxCoef;

  if (!pricingBounds) {
    throw new Error('ERR_PRICING_BOUNDS_NOT_PROVIDED');
  } else if (!pricingBounds.IMPRESSION) {
    throw new Error('ERR_PRICING_BOUNDS_IMPRESSION_NOT_PROVIDED');
  }

  var pricingBoundsInRuleValue = {
    IMPRESSION: {
      min: userInputValuePerMileToTokenValue({
        value: pricingBounds.IMPRESSION.min,
        decimals: decimals,
        divBy: minCoef
      }),
      max: userInputValuePerMileToTokenValue({
        value: pricingBounds.IMPRESSION.max,
        decimals: decimals,
        mulBy: maxCoef
      })
    }
  };
  return pricingBoundsInRuleValue;
};

var pricingBondsToUserInputPerMile = function pricingBondsToUserInputPerMile(_ref26) {
  var pricingBounds = _ref26.pricingBounds,
      decimals = _ref26.decimals;

  if (!pricingBounds) {
    throw new Error('ERR_PRICING_BOUNDS_NOT_PROVIDED');
  } else if (!pricingBounds.IMPRESSION) {
    throw new Error('ERR_PRICING_BOUNDS_IMPRESSION_NOT_PROVIDED');
  }

  var pricingBoundsCPMUserInput = {
    IMPRESSION: {
      min: bondPerActionToUserInputPerMileValue(pricingBounds.IMPRESSION.min, decimals),
      max: bondPerActionToUserInputPerMileValue(pricingBounds.IMPRESSION.max, decimals)
    }
  };
  return pricingBoundsCPMUserInput;
};

module.exports = {
  ipfsHashTo32BytesHex: ipfsHashTo32BytesHex,
  from32BytesHexIpfs: from32BytesHexIpfs,
  toLowerCaseString: toLowerCaseString,
  getAdSizeByType: getAdSizeByType,
  getMediaUrlWithProvider: getMediaUrlWithProvider,
  audienceInputToTargetingRules: audienceInputToTargetingRules,
  slotRulesInputToTargetingRules: slotRulesInputToTargetingRules,
  getSuggestedPricingBounds: getSuggestedPricingBounds,
  userInputPricingBoundsPerMileToRulesValue: userInputPricingBoundsPerMileToRulesValue,
  userInputValuePerMileToTokenValue: userInputValuePerMileToTokenValue,
  pricingBondsToUserInputPerMile: pricingBondsToUserInputPerMile,
  bondPerActionToUserInputPerMileValue: bondPerActionToUserInputPerMileValue
};